/* Matcha Sunday — "Bold Green" landing page interactions. Self-contained.
   The sticky add-to-cart reuses the PROVEN pattern from the live LPs: a button with
   form="<hero form id>" so the shared ms-supply.js adds to cart with the live picker
   selection and writes the price into the button label. No separate form, no sync needed.
   This script only handles: the quantity +/- buttons, the sticky bar show/hide on scroll,
   and the interactive Green Meter. */
(function () {
  // (Quantity +/- and the cart are handled by ms-landing.js + the global ms-supply.js, exactly
  //  like the Coffee Crash page. This script ONLY drives the green meter + the bfcache re-enable.)

  // Interactive Green Meter: drag from "dull supermarket" to "Matcha Sunday". The marker,
  // the matcha photo (dull yellow-olive -> natural vivid green), and the caption track the drag.
  function initMeter() {
    var m = document.getElementById('bld-meter'); if (!m) return;
    m.classList.add('js-on');
    var scale = document.getElementById('bld-meter-scale');
    var marker = m.querySelector('.bld__meter-marker');
    var dull = m.querySelector('.bld__meter-photo--dull');
    var note = document.getElementById('bld-meter-note');
    if (!scale || !marker) return;
    var MIN = 4, MAX = 96;
    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
    function setT(t, animate) {
      t = clamp(t, 0, 1);
      marker.style.transition = animate ? 'left 1s cubic-bezier(.22,1,.36,1)' : 'none';
      marker.style.left = (MIN + t * (MAX - MIN)) + '%';
      marker.style.opacity = '1';
      marker.style.transform = 'translate(-50%,-50%) scale(1)';
      if (dull) {
        // crossfade to the REAL dull-powder image (good -> dull), a true color change not a desaturation
        dull.style.transition = animate ? 'opacity 1s ease' : 'none';
        dull.style.opacity = (1 - t).toFixed(3);
      }
      scale.setAttribute('aria-valuenow', Math.round(t * 100));
      if (note) {
        if (t < 0.34) note.textContent = 'Down here: dull olive or yellow powder. Usually older, lower grade leaf, and it often tastes bitter.';
        else if (t < 0.72) note.textContent = 'Greener, fresher leaf, but still not first harvest ceremonial grade.';
        else note.textContent = 'This is Matcha Sunday. A natural vivid green means first harvest, shade grown, stone milled. You can taste the difference.';
      }
    }
    function pct(e) {
      var r = scale.getBoundingClientRect();
      return clamp(((e.touches ? e.touches[0].clientX : e.clientX) - r.left) / r.width, 0, 1);
    }
    // Pointer capture on the slider only — NO window listeners (those fire on every scroll/tap and lag the page on mobile).
    var dragging = false;
    scale.addEventListener('pointerdown', function (e) { dragging = true; scale.classList.add('is-drag'); try { scale.setPointerCapture(e.pointerId); } catch (_) {} setT(pct(e), false); e.preventDefault(); });
    scale.addEventListener('pointermove', function (e) { if (dragging) setT(pct(e), false); });
    scale.addEventListener('pointerup', function (e) { dragging = false; scale.classList.remove('is-drag'); try { scale.releasePointerCapture(e.pointerId); } catch (_) {} });
    scale.addEventListener('pointercancel', function () { dragging = false; scale.classList.remove('is-drag'); });
    scale.addEventListener('keydown', function (e) {
      var cur = (parseInt(scale.getAttribute('aria-valuenow'), 10) || 100) / 100;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { setT(cur + 0.1, true); e.preventDefault(); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { setT(cur - 0.1, true); e.preventDefault(); }
    });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    setT(reduce ? 1 : 0, false); // start dull, reveal to vivid on scroll-in
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es, o) { es.forEach(function (en) { if (en.isIntersecting) { setT(1, true); o.disconnect(); } }); }, { threshold: 0.4 });
      io.observe(m);
    } else { setT(1, false); }
  }

  function init() { initMeter(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);

  // BFCACHE FIX: ms-supply.js disables the buy buttons while it navigates to checkout. When the
  // user hits Back, Safari/Chrome restore this page from the back-forward cache in that disabled
  // state, so re-adding after deleting from the cart does nothing. Re-enable on every pageshow.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.bld .mslp__atc, #mslp-sticky .mslp__sticky-atc').forEach(function (b) {
      b.disabled = false; b.removeAttribute('aria-busy');
    });
  });
})();
